// CmcUsageWidget/CmcUsageEngine.js
// Engine Pattern (rk=f03ae8b6) — extends EngineCleanupBase, singleton export.
// fetch() is triggered explicitly by PageContent, same as FearGreedEngine.
// SignalR push not wired yet (onUsageReceived exists, event-name TBD — same open item as FearGreed).
import EngineCleanupBase from '../../../services/engines/EngineCleanupBase';
import ComponentNotifier from '../../../services/wss/ComponentNotifier';
import cmcUsageCache from './CmcUsageCache';
import cmcUsageFetcher from './CmcUsageFetcher';
import CmcUsageCalculator from './CmcUsageCalculator';

const _name = 'CmcUsageEngine';

class CmcUsageEngine extends EngineCleanupBase {
    bootup = () => {
        this.initialize(_name);
    };

    /**
     * SignalR handler — called from PageContentSRHandlers on new pushed usage items.
     * @param {object[]} rawItems - raw CmcUsageItemDto items
     */
    onUsageReceived = (rawItems) => {
        try {
            cmcUsageCache.addOrUpdate(CmcUsageCalculator.normalize(rawItems));
            this._notify();
        } catch (error) {
            this.logError('onUsageReceived', error.message);
        }
    };

    /**
     * @returns {object|null} render-state derived from the cached usage items
     */
    getState = () => CmcUsageCalculator.buildState(cmcUsageCache.getAll());

    /**
     * Fetches the current usage items via REST. Called once from PageContent
     * alongside the other engines' fetch/fetchAll calls.
     * @returns {Promise<void>}
     */
    fetch = async () => {
        try {
            const rawItems = await cmcUsageFetcher.fetch();
            if (!rawItems.length) return;

            cmcUsageCache.addOrUpdate(CmcUsageCalculator.normalize(rawItems));
            this._notify();
        } catch (error) {
            this.logError('fetch', error.message);
        }
    };

    _notify = () => {
        ComponentNotifier.notify(_name, 'dataChanged', { state: this.getState() });
    };
}

const cmcUsageEngine = new CmcUsageEngine();
export default cmcUsageEngine;
